export default __webpack_public_path__ + "static/media/icon-machineLearningOptimize.0122de92.svg";